<template>
	<v-card flat outlined>
		<v-card-text class="pb-0 pl-6 pt-4">
			<v-row>
				<v-col cols="4">
					<v-row>
						<v-col class="pb-0 pt-0">
							<div :class="['text-h6', 'justify-left', 'align-center', 'pb-0', 'pt-0']">
								{{ $t('titles.loyaltyInformations') }}
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<InputField
								:readonly="true"
								v-model="currentLoyaltyPoints"
								:label="$t('fields.loyaltyPoints')"
							></InputField>
						</v-col>
						<v-col cols="12">
							<NumberField
								:readonly="true"
								v-model="nextLoyaltyPointsExpirationAmount"
								:label="$t('fields.amountForExpiration')"
							></NumberField>
						</v-col>
						<v-col cols="12">
							<DatePicker
								:readonly="true"
								v-model="nextLoyaltyPointsExpirationDate"
								:date-label="$t('fields.expirationDate')"
							></DatePicker>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="8">
					<v-row class="d-flex justify-space-between">
						<v-col class="pb-0 pt-0">
							<div :class="['text-h6', 'justify-left', 'align-center', 'pl-4', 'pb-0', 'pt-0']">
								{{ $t('titles.loyaltyTransactions') }}
							</div>
						</v-col>
						<v-col class="d-flex justify-end align-center pb-2 pt-0 pl-2">
							<v-btn color="basicButton" @click="manuallyAdjustLoyaltyPoints()">
								{{ $t('buttons.manuallyAdjust') }}
								<v-icon small class="ml-2">fas fa-user-plus</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<v-col cols="12" class="pb-0 pt-0 pr-0">
						<v-card flat outlined class="pb-0 pt-0">
							<v-card-text class="pb-0">
								<v-row>
									<v-col class="pt-0">
										<TheTable
											:additional-filters="loyaltyTransactionsTable.additionalFilters"
											:default-sort="loyaltyTransactionsTable.defaultSort"
											:excel="false"
											:fields="loyaltyTransactionsTable.headers"
											:header-selection-key="'loyalty-transactions-headers'"
											:height="loyaltyTransactionsTable.height"
											:total-records="loyaltyTransactionsTable.total"
											@headers="selectHeaders"
											@reload="reloadData"
										>
											<tr
												v-for="(item, key) in loyaltyTransactionsTable.items"
												:key="key"
												:class="{ 'cursor-pointer': true }"
											>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes(
															'loyalty_transactions_type_id'
														)
													"
												>
													<span v-if="item.loyalty_transaction_type_id == 3 && item.author">
														{{ item.loyalty_transaction_type.name }}&nbsp;{{
															'(' +
															item.author.first_name +
															' ' +
															item.author.last_name +
															')'
														}}
													</span>
													<span v-else>
														{{ item.loyalty_transaction_type.name }}
													</span>
												</td>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes(
															'payment_contract_id'
														)
													"
												>
													{{
														item.payment_contract_id != null
															? 'ID: ' +
															  item.payment_contract.id +
															  ' | ' +
															  item.date.split('-').reverse().join('.') +
															  '.'
															: '-'
													}}
												</td>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes('created_at')
													"
												>
													{{ item.created_at }}
												</td>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes(
															'loyalty_points_state'
														)
													"
												>
													{{ item.loyalty_points_state }}
												</td>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes(
															'change_amount'
														)
													"
												>
													{{ item.change_amount }}
												</td>
												<td
													v-if="
														loyaltyTransactionsTable.selectedHeaders.includes('final_state')
													"
												>
													{{
														item.loyalty_points_state + item.change_amount > 0
															? item.loyalty_points_state + item.change_amount
															: 0
													}}
												</td>
											</tr>
										</TheTable>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-col>
			</v-row>
			<v-row v-if="showModal">
				<v-col>
					<Modal :show-modal="showModal">
						<LoyaltyTransaction @close="closeModal"></LoyaltyTransaction>
					</Modal>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import NumberField from '../../trinkets/NumberField';
import InputField from '../../trinkets/InputField';
import DatePicker from '../../trinkets/DatePicker';
import LoyaltyTransaction from './LoyaltyTransaction';

export default {
	name: 'Costs',
	components: { TheTable, Modal, InputField, NumberField, DatePicker, LoyaltyTransaction },
	props: {
		candidateLoyaltyPoints: Number,
	},
	data: function () {
		return {
			loyaltyTransactionsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.type'),
						value: 'loyalty_transactions_type_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.paymentContract'),
						value: 'payment_contract_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.date'), value: 'created_at', type: '', allowFilter: true },
					{
						text: this.$t('fields.startingState'),
						value: 'loyalty_points_state',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.stateChange'),
						value: 'change_amount',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.finalState'),
						value: 'final_state',
						type: '',
						sortable: false,
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'created_at',
					descending: true,
				},
			},
			showModal: false,
			nextLoyaltyPointsExpirationAmount: 0,
			nextLoyaltyPointsExpirationDate: null,
			currentLoyaltyPoints: this.candidateLoyaltyPoints,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.loyaltyTransactionsTable.selectedHeaders = headers;
		},
		manuallyAdjustLoyaltyPoints() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reloadData(request) {
			this.loyaltyTransactionsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'loyalty-transactions/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.loyaltyTransactionsTable.items = data.items;
						vm.loyaltyTransactionsTable.total = data.total;
						vm.nextLoyaltyPointsExpirationAmount = data.nextExpirationPoints;
						vm.nextLoyaltyPointsExpirationDate = data.nextExpirationDate;
						vm.currentLoyaltyPoints = data.candidateLoyaltyPoints;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.loyaltyTransactionsTable.height = window.innerHeight - 340 + 'px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadLoyaltyTransactions', () => {
			vm.reloadData(vm.loyaltyTransactionsTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
